import { render, staticRenderFns } from "./tabSwitch.vue?vue&type=template&id=37b955fb"
import script from "./tabSwitch.vue?vue&type=script&lang=js"
export * from "./tabSwitch.vue?vue&type=script&lang=js"
import style0 from "./tabSwitch.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports